import React from "react";
import { getStates } from "../../services/helpers";
import MonthYearPicker from "../component-tools/MonthYearPicker";

export interface BishopsReligious {
  bishopName: string;
  diocese: string;
  brEmail: string;
  brPhone: string;
  brAddress: string;
  brCity: string;
  brState: string;
  brZipCode: string;
  brFromDate: Date;
  brToDate: Date;
  brCurrent: boolean;
  brMailingAddressDifferent: boolean;
  brMailingAddress: string;
  brMailingCity: string;
  brMailingState: string;
  brMailingZipCode: string;
}

interface BishopsReligiousFormProps {
  bishopsReligious: BishopsReligious;
  validationErrors: { [key: string]: string };
  onInputChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    field: string,
    index: number
  ) => void;
  onDelete: () => void;
  index: number;
}

const BishopsReligiousForm: React.FC<BishopsReligiousFormProps> = ({
  bishopsReligious,
  validationErrors,
  onInputChange,
  onDelete,
  index,
}) => {
  const states = getStates();
  return (
    <div className="data-container">
      <div className="text-sub-sub-header" style={{ flex: "0 0 100%" }}>
        Bishops/Religious Supervisor #{index + 1}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 40%" }}>
        <label className="field-label">
          Name of Bishop/Religious Supervisor:
        </label>
        <input
          className={`form-control ${
            validationErrors[`bishopName-${index}`] ? "is-invalid" : ""
          }`}
          type="text"
          value={bishopsReligious.bishopName || ""}
          onChange={(e) => onInputChange(e, "bishopName", index)}
        />
        {validationErrors[`bishopName-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`bishopName-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 35%" }}>
        <label className="field-label">Diocese/Organization Name:</label>
        <input
          className={`form-control ${
            validationErrors[`diocese-${index}`] ? "is-invalid" : ""
          }`}
          type="text"
          value={bishopsReligious.diocese || ""}
          onChange={(e) => onInputChange(e, "diocese", index)}
        />
        {validationErrors[`diocese-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`diocese-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 40%" }}>
        <label className="field-label">Email:</label>
        <input
          className={`form-control ${
            validationErrors[`brEmail-${index}`] ? "is-invalid" : ""
          }`}
          type="email"
          value={bishopsReligious.brEmail || ""}
          onChange={(e) => onInputChange(e, "brEmail", index)}
        />
        {validationErrors[`brEmail-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`brEmail-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">Phone:</label>
        <input
          className={`form-control ${
            validationErrors[`brPhone-${index}`] ? "is-invalid" : ""
          }`}
          type="tel"
          value={bishopsReligious.brPhone || ""}
          onChange={(e) => onInputChange(e, "brPhone", index)}
        />
        {validationErrors[`brPhone-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`brPhone-${index}`]}
          </div>
        )}
      </div>
      <div className="field-stacked" style={{ flex: "0 0 20%" }}></div>

      <div className="field-stacked" style={{ flex: "0 0 30%" }}>
        <label className="field-label">Address:</label>
        <input
          className={`form-control ${
            validationErrors[`brAddress-${index}`] ? "is-invalid" : ""
          }`}
          type="text"
          value={bishopsReligious.brAddress || ""}
          onChange={(e) => onInputChange(e, "brAddress", index)}
        />
        {validationErrors[`brAddress-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`brAddress-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">City:</label>
        <input
          className={`form-control ${
            validationErrors[`brCity-${index}`] ? "is-invalid" : ""
          }`}
          type="text"
          value={bishopsReligious.brCity || ""}
          onChange={(e) => onInputChange(e, "brCity", index)}
        />
        {validationErrors[`brCity-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`brCity-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">State:</label>
        <select
          className={`form-select ${
            validationErrors[`brState-${index}`] ? "is-invalid" : ""
          }`}
          value={bishopsReligious.brState || ""}
          onChange={(e) => onInputChange(e, "brState", index)}
        >
          <option value="">Select State</option>
          {states.map((state) => (
            <option key={state.abbreviation} value={state.abbreviation}>
              {state.name} ({state.abbreviation})
            </option>
          ))}
        </select>
        {validationErrors[`brState-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`brState-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">Zip Code:</label>
        <input
          className={`form-control ${
            validationErrors[`brZipCode-${index}`] ? "is-invalid" : ""
          }`}
          type="text"
          value={bishopsReligious.brZipCode || ""}
          onChange={(e) => onInputChange(e, "brZipCode", index)}
        />
        {validationErrors[`brZipCode-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`brZipCode-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">From Date:</label>
        <MonthYearPicker
          value={bishopsReligious.brFromDate}
          onChange={(newDate) =>
            onInputChange(
              { target: { value: newDate } } as any,
              "brFromDate",
              index
            )
          }
        />
        {validationErrors[`brFromDate-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`brFromDate-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">To Date:</label>
        <MonthYearPicker
          value={bishopsReligious.brToDate}
          onChange={(newDate) =>
            onInputChange(
              { target: { value: newDate } } as any,
              "brToDate",
              index
            )
          }
        />
        {validationErrors[`brToDate-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`brToDate-${index}`]}
          </div>
        )}
      </div>

      <div className="field-long" style={{ flex: "0 0 20%" }}>
        <label className="field-label">Is Current:</label>
        <div>
          <input
            className="form-check-input"
            type="checkbox"
            checked={bishopsReligious.brCurrent}
            onChange={(e) =>
              onInputChange(
                e as React.ChangeEvent<HTMLInputElement>,
                "brCurrent",
                index
              )
            }
          />
        </div>
      </div>

      <div className="field-long" style={{ flex: "0 0 100%" }}>
        <div>
          <input
            className="form-check-input"
            type="checkbox"
            checked={bishopsReligious.brMailingAddressDifferent}
            onChange={(e) =>
              onInputChange(
                e as React.ChangeEvent<HTMLInputElement>,
                "brMailingAddressDifferent",
                index
              )
            }
          />
        </div>
        <label className="field-label" style={{ textWrap: "wrap" }}>
          Mailing Address Different than Physical Address
        </label>
      </div>

      {bishopsReligious.brMailingAddressDifferent && (
        <>
          <div className="field-stacked" style={{ flex: "0 0 40%" }}>
            <label className="field-label">Mailing Address:</label>
            <input
              className={`form-control ${
                validationErrors[`brMailingAddress-${index}`]
                  ? "is-invalid"
                  : ""
              }`}
              type="text"
              value={bishopsReligious.brMailingAddress || ""}
              onChange={(e) => onInputChange(e, "brMailingAddress", index)}
            />
            {validationErrors[`brMailingAddress-${index}`] && (
              <div className="invalid-feedback">
                {validationErrors[`brMailingAddress-${index}`]}
              </div>
            )}
          </div>

          <div className="field-stacked" style={{ flex: "0 0 20%" }}>
            <label className="field-label">Mailing City:</label>
            <input
              className={`form-control ${
                validationErrors[`brMailingCity-${index}`] ? "is-invalid" : ""
              }`}
              type="text"
              value={bishopsReligious.brMailingCity || ""}
              onChange={(e) => onInputChange(e, "brMailingCity", index)}
            />
            {validationErrors[`brMailingCity-${index}`] && (
              <div className="invalid-feedback">
                {validationErrors[`brMailingCity-${index}`]}
              </div>
            )}
          </div>

          <div className="field-stacked" style={{ flex: "0 0 20%" }}>
            <label className="field-label">Mailing State:</label>
            <select
              className={`form-select ${
                validationErrors[`brMailingState-${index}`] ? "is-invalid" : ""
              }`}
              value={bishopsReligious.brMailingState || ""}
              onChange={(e) => onInputChange(e, "brMailingState", index)}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.abbreviation} value={state.abbreviation}>
                  {state.name} ({state.abbreviation})
                </option>
              ))}
            </select>
            {validationErrors[`brMailingState-${index}`] && (
              <div className="invalid-feedback">
                {validationErrors[`brMailingState-${index}`]}
              </div>
            )}
          </div>

          <div className="field-stacked" style={{ flex: "0 0 20%" }}>
            <label className="field-label">Mailing Zip Code:</label>
            <input
              className={`form-control ${
                validationErrors[`brMailingZipCode-${index}`]
                  ? "is-invalid"
                  : ""
              }`}
              type="text"
              value={bishopsReligious.brMailingZipCode || ""}
              onChange={(e) => onInputChange(e, "brMailingZipCode", index)}
            />
            {validationErrors[`brMailingZipCode-${index}`] && (
              <div className="invalid-feedback">
                {validationErrors[`brMailingZipCode-${index}`]}
              </div>
            )}
          </div>
        </>
      )}

      <div style={{ flex: "0 0 100%" }}>
        <button className="oxbtn btn-red" onClick={onDelete}>
          Delete
        </button>
      </div>
    </div>
  );
};

export default BishopsReligiousForm;
